var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"privacy-box",attrs:{"outlined":"","tile":""},domProps:{"innerHTML":_vm._s(_vm.$t('common.privacy'))}})}
var staticRenderFns = []

export { render, staticRenderFns }